import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { FormGroup, Input, Label } from 'reactstrap'

interface IArrayTextFieldProps {
  list?: string[],
  label?: string,
  id?: string,
  name?: string,
  className?: string,
  placeholder?: string,
  disabled?: boolean,
  submitList?: Function;
  itemDelete?: (value: any) => void;
}

const ArrayTextField = (props: IArrayTextFieldProps) => {
  const { list, label, id, name, className, placeholder, disabled, submitList, itemDelete } = props;

  const [ example, setExample ] = useState('')

  const handleSubmit = () => {
    submitList && submitList([...(list ?? []), example])
    setExample('')
  }

  return (
    <FormGroup className='input-list-form'>
      <Label className='input-list-label' for="attrExamples">
        {label}
        {example ? <div className='btns'>
          <FontAwesomeIcon icon={faCheck} onClick={handleSubmit} />
          <FontAwesomeIcon icon={faXmark} onClick={() => setExample('')} />
          </div>: <></>}
      </Label>
      <Input
        id={id || 'inputList'}
        name={name || 'inputList'}
        className={className || 'inputList'}
        placeholder={placeholder}
        disabled={disabled}
        value={example}
        onChange={e => setExample(e?.target?.value)}
      />
      {list && list?.length > 0 ? <div className="display-list">
        { list?.map(each => <div className="display-item" key={each}>
          <div className="text">{each}</div>
          <div className="close" onClick={() => itemDelete && itemDelete(each)}>
            <FontAwesomeIcon icon={faXmark} />
          </div>
        </div>) }
      </div> : <></>}
    </FormGroup>
  )
}

export default ArrayTextField